
// Hilfsfunktionen
function isHoliday(date, holidays) {
  // Ist ein Feiertag?
  const dateStr = date.toISOString().split('T')[0]; // Format: YYYY-MM-DD
  return holidays.includes(dateStr);
}

function getAllHolidays() {
  // alle Feiertage lesen
  const allHolidays = new Set();
    
  if (window.shopMetafields?.holidays) {
    Object.values(window.shopMetafields.holidays).forEach(holidayList => {
      holidayList.forEach(holiday => allHolidays.add(holiday));
    });
  }
    
  return Array.from(allHolidays).sort();
}

function addWeekdays(start, days) {
  // Arbeitstag hinzufügen
  const result = new Date(start);
  let added = 0;
  const allHolidays = getAllHolidays();
    
  while (added < days) {
    result.setDate(result.getDate() + 1);
      
    // Überspringe Sonntage und Feiertage
    if (result.getDay() !== 0 && !isHoliday(result, allHolidays)) {
      added++;
    }
  }
  return result;
}

function formatDate(d) {
  return (
    ("0" + d.getDate()).slice(-2) +
    "." +
    ("0" + (d.getMonth() + 1)).slice(-2) +
    "." +
    d.getFullYear()
  );
}
  
function parseGermanDate(dateStr) {
  const [day, month, year] = dateStr.split('.').map(Number);
  return new Date(year, month - 1, day);
}

function formDataToObject(formData) {
  const obj = {};

  for (const [key, value] of formData.entries()) {
    obj[key] = value;
  }

  return obj;
}

function extractBody(body) {

  // FormData
  if (body instanceof FormData) {
    return {
      type: 'formdata',
      data: formDataToObject(body)
    };
  }

  // JSON-String
  if (typeof body === 'string') {
    try {
      return {
        type: 'string',
        data: JSON.parse(body)
      };
    } catch {
      return null;
    }
  }

  // Objekt
  if (typeof body === 'object' && body !== null) {
    return {
      type: 'object',
      data: body
    };
  }

  return null;
}


// Hauptfunktionen
async function fetchVariantMetafields(variantId) {
  // Variant Metafields holen
  const query = `{
    node(id: "gid://shopify/ProductVariant/${variantId}") {
      ... on ProductVariant {
        metafield1: metafield(namespace: "custom", key: "lieferbar_ab") {
          value
        }
        metafield2: metafield(namespace: "custom", key: "lieferzeit_von") {
          value
        }
        metafield3: metafield(namespace: "custom", key: "lieferzeit_bis") {
          value
        }
      }
    }
  }`;
  
  const response = await fetch('/api/2024-10/graphql.json', {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': 'aa4fbc8b7de90c277c561a47622758a9'
    },
    body: JSON.stringify({ query })
  });
  
  if (!response.ok) {
    throw new Error('API request failed');
  }

  const data = await response.json();
  const node = data?.data?.node;
    
  return {
    lieferbar_ab: node?.metafield1?.value || null,
    lieferzeit_von: parseInt(node?.metafield2?.value) || null,
    lieferzeit_bis: parseInt(node?.metafield3?.value) || null
  };
}

function CalculateDeliveryDate(data) {
  // -------------------------------------------
  // product-metafields auslesen
  // -------------------------------------------
  const metafieldEl = document.getElementById("product-metafields");
  if (!metafieldEl) {
    return args;
  }

  let meta = {};
  try {
    meta = JSON.parse(metafieldEl.textContent || "{}");
  } catch (err) {
    return args;
  }

  // -------------------------------------------
  // Lieferzeit berechnen
  // -------------------------------------------

  // qbk Plugin?
  if(data && data.data && data.data.items){
    const hasQbkProperty = data.data.items.some(item => {
      if (!item.properties) return false;
      return Object.keys(item.properties).some(key => key.startsWith('_qbk-'));
    });
    if(hasQbkProperty){
      return "";
    }
  }
 
  // Daten vorhanden?
  let value = "";
  if(!(meta.lieferbar_ab == null && meta.lieferzeit_von == null && meta.lieferzeit_bis == null) &&
     !(meta.lieferbar_ab == '' && meta.lieferzeit_von == '' && meta.lieferzeit_bis == '') ){
    const von = parseInt(meta.lieferzeit_von || 0);
    const bis = parseInt(meta.lieferzeit_bis || 0);
    let now = new Date(Date.now());
    now.setHours(0, 0, 0, 0);
    const lieferbarAbDate = (meta.lieferbar_ab && meta.lieferbar_ab.trim()) ? parseGermanDate(meta.lieferbar_ab) : null;
    const startDate = (lieferbarAbDate > now) ? lieferbarAbDate : now;
    value = formatDate(addWeekdays(startDate, von)) + " bis " + formatDate(addWeekdays(startDate, bis));   
  }
  
  return value;
}

function interceptAddToCart(...args) {
  let body = args[1]?.body;
  let value = "";

  if (!body) {
    console.warn('Kein body vorhanden.');
    return args;
  }

  if (body instanceof FormData) {
    if (!body.has('properties[_gpo_parent_product_group]')) {
      value = CalculateDeliveryDate(extractBody(body));
      if(value != ""){
        body.set('properties[Voraussichtlicher Lieferzeitraum]', value);
      }
    }

  } else if (typeof body === 'string') {
    try {
      const parsed = JSON.parse(body);

      if (parsed.items && Array.isArray(parsed.items)) {
        parsed.items.forEach(item => {
          if (!item.properties) item.properties = {};
          if(!item.properties["_gpo_parent_product_group"]){
            value = CalculateDeliveryDate(extractBody(body));
            if(value != ""){
              item.properties["Voraussichtlicher Lieferzeitraum"] = value;
            }
          }
        });
      }

      args[1].body = JSON.stringify(parsed);

    } catch (e) {
      console.warn('Body ist ein String, aber kein JSON:', e);
    }

  } else if (typeof body === 'object') {
    // body ist bereits ein Objekt
    if (body.items && Array.isArray(body.items)) {
      body.items.forEach(item => {
        if (!item.properties) item.properties = {};
        if(!item.properties["_gpo_parent_product_group"]){
          value = CalculateDeliveryDate(extractBody(body));
          if(value != ""){
            item.properties["Voraussichtlicher Lieferzeitraum"] = value;
          }
        }
      });
    }

  } else {
    console.warn('Unbekanntes Body-Format:', body);
  }

  return args;
}

// Einstiegspunkte
(function() {
  const originalFetch = window.fetch;
  
  if (window.__cartFetchIntercepted) return;
  window.__cartFetchIntercepted = true;

  const CART_ADD_PATH = '/cart/add';

  window.fetch = function(...args) {
    const url = args[0];
    
    if (typeof url !== 'string') {
      return originalFetch.apply(this, args);
    }

    const isCartAdd = url.includes(CART_ADD_PATH);

    if (!isCartAdd) {
      return originalFetch.apply(this, args)
        .catch(err => {
          console.warn('Fetch abgefangen:', err);
          return new Response(JSON.stringify({}), {
            status: 200,
            headers: { 'Content-Type': 'application/json' }
          });        
        });
    }

    try {
      args = interceptAddToCart(...args);
    } catch (err) {
      console.error('[Cart] Fehler in interceptAddToCart:', err);
    }

    return originalFetch.apply(this, args)
      .then(response => {
        return response;
      })
      .catch(err => {
        console.error('[Cart] Fetch fehlgeschlagen:', err);
        throw err;
      });
  };
})();

document.addEventListener('DOMContentLoaded', function() {
  
  document.addEventListener('click', async function(e) {
    const button = e.target.closest('[name="checkout"]:not([name="update"]), button[name="checkout"], .cart__checkout-button, .cart__checkout, [href="/checkout"]');
    
    if (e.target.closest('.cart__remove, [href*="/cart/change"], [data-cart-remove], .cart-item__remove')) {
      return;
    }
    
    if (!button) return;
    
    if (button.dataset.processingCheckout === 'true') {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }
    
    e.preventDefault();
    e.stopImmediatePropagation();
    
    button.dataset.processingCheckout = 'true';
    button.disabled = true;
    
    const originalText = button.textContent;
    button.textContent = 'Wird vorbereitet...';
    
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      
      const updates = [];
      
      for (let item of cart.items) {
        const variantId = item.variant_id;
        //const metafields = await fetchVariantMetafields(variantId);
        const metafields = {};

        if((metafields.lieferbar_ab == null && metafields.lieferzeit_von == null && metafields.lieferzeit_bis == null) ||
           (metafields.lieferbar_ab == '' && metafields.lieferzeit_von == '' && metafields.lieferzeit_bis == '')) {
          metafields.lieferzeit_von = "7";
          metafields.lieferzeit_bis = "10";
        }

        let value = "";
        if(!item.properties["_gpo_parent_product_group"]){
          if(!(metafields.lieferbar_ab == null && metafields.lieferzeit_von == null && metafields.lieferzeit_bis == null) &&
            !(metafields.lieferbar_ab == '' && metafields.lieferzeit_von == '' && metafields.lieferzeit_bis == '')) {
            const von = parseInt(metafields.lieferzeit_von || 0);
            const bis = parseInt(metafields.lieferzeit_bis || 0);
            let now = new Date(Date.now());
            now.setHours(0, 0, 0, 0);
            const lieferbarAbDate = (metafields.lieferbar_ab && metafields.lieferbar_ab.trim()) ? parseGermanDate(metafields.lieferbar_ab) : null;
            const startDate = (lieferbarAbDate > now) ? lieferbarAbDate : now;
            value = formatDate(addWeekdays(startDate, von)) + " bis " + formatDate(addWeekdays(startDate, bis));   
          }
        }
        
        if(value) {
          updates.push({
            id: item.key,
            quantity: item.quantity,
            properties: {
              ...item.properties,
              'Voraussichtlicher Lieferzeitraum': value
            }
          });
        }
      }
      
      for (let update of updates) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(update)
        });
      }
      
      await new Promise(resolve => setTimeout(resolve, 300));
      
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = '/cart';
      
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'checkout';
      input.value = '1';
      
      form.appendChild(input);
      document.body.appendChild(form);
      form.submit();
      
    } catch (error) {
      console.error('Fehler bei Checkout-Vorbereitung:', error);
      
      button.dataset.processingCheckout = 'false';
      button.disabled = false;
      button.textContent = originalText;
      
      alert('Ein Fehler ist aufgetreten. Bitte versuche es erneut.');
    }
    
  }, true);
  
});